import { Button, Icon, Text } from 'components';
import { theme } from 'lib';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const PaymentFailure = () => {
    const { t } = useTranslation(),
        navigate = useNavigate(),
        { isMobile } = useSelector((state) => state.appState);

    return (
        <div className="flex flex-col items-center justify-center w-full min-h-[calc(100vh-100px)] bg-[#F8F9FA] p-5">
            <div className={`flex flex-col items-center justify-center w-full max-w-[480px] ${isMobile ? 'p-6' : 'p-10'} bg-white/90 backdrop-blur-md rounded-[24px] shadow-[0_20px_40px_rgba(0,0,0,0.1)] border border-white/30 animate-in fade-in slide-in-from-bottom-5 duration-700`}>

                <div className="flex flex-col items-center justify-center mb-10 w-full">
                    <div
                        className="flex items-center justify-center w-20 h-20 rounded-full mb-6 shadow-[0_8px_16px_rgba(250,63,88,0.4)]"
                        style={{ background: theme.SECONDARY }}
                    >
                        <Icon type="close" dimensions={40} col="#fff" />
                    </div>

                    <Text h3={isMobile} h2={!isMobile} center>{t('subscription.paymentFailed')}</Text>
                    <Text b2 col={theme.GREY_50} marg="8px 0 0" center size={isMobile ? '13px' : '14px'}>
                        {t('subscription.failureReason')}
                    </Text>
                </div>

                <div className="w-full space-y-4 flex flex-col items-center">
                    <Button
                        text={t('subscription.tryAgain')}
                        onClick={() => navigate(-3)}
                        wid="100%"
                        big
                    />

                    <Button
                        text={t('common.goToHome')}
                        onClick={() => navigate('/')}
                        wid="100%"
                        bordered
                        big
                    />

                    <a
                        href="mailto:support@playaz.com"
                        className="mt-4 font-semibold no-underline text-sm hover:underline"
                        style={{ color: theme.SECONDARY }}
                    >
                        {t('subscription.contactSupport')}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailure;
